module.exports = __webpack_public_path__ + "img/barryThumbnail.9af86925.png";